module.exports = __webpack_public_path__ + "static/media/featured_listing_2.51645e67.jpg";